(()=>{
  const KEY='marastoni:wishlist:v1';
  const read=()=>{try{return JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){return[]}};
  const write=(items)=>{localStorage.setItem(KEY,JSON.stringify(items));render()};
  const escapeHtml=(s='')=>String(s).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  const updateButtons=()=>{
    const items=read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn=>{
      const active=items.some(x=>x.handle===btn.dataset.productHandle);
      btn.setAttribute('aria-pressed',active?'true':'false');
      const label=btn.querySelector('.marastoni-wishlist-toggle__label');
      if(label) label.textContent=active?'Fjern fra ønskeliste':'Tilføj til ønskeliste';
    });
    document.querySelectorAll('[data-wishlist-header]').forEach(btn=>btn.classList.toggle('has-items',items.length>0));
    document.querySelectorAll('[data-wishlist-count]').forEach(el=>{el.textContent='';el.hidden=!items.length});
  };

  const renderDrawer=()=>{
    const host=document.querySelector('[data-wishlist-items]');
    if(!host)return;
    const items=read();
    if(!items.length){
      host.innerHTML='<div class="marastoni-wishlist-empty">Din ønskeliste er tom. Tryk på hjertet ved et produkt for at gemme det her.</div>';
      return;
    }
    host.innerHTML='<div class="marastoni-wishlist-list">'+items.map(item=>`<article class="marastoni-wishlist-item"><a href="${escapeHtml(item.url)}">${item.image?`<img class="marastoni-wishlist-item__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`:''}</a><div><a class="marastoni-wishlist-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a><div class="marastoni-wishlist-item__price">${escapeHtml(item.price||'')}</div></div><button type="button" class="marastoni-wishlist-item__remove" data-wishlist-remove="${escapeHtml(item.handle)}" aria-label="Fjern ${escapeHtml(item.title)} fra ønskeliste">×</button></article>`).join('')+'</div>';
  };

  const updateCartState=(count)=>{
    const hasItems=Number(count)>0;
    document.querySelectorAll('[data-marastoni-cart-state]').forEach(el=>el.classList.toggle('has-items',hasItems));
    document.querySelectorAll('[data-marastoni-cart-indicator]').forEach(el=>{el.hidden=!hasItems});
  };

  const refreshCartState=async()=>{
    try{
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{credentials:'same-origin'});
      if(response.ok){const cart=await response.json();updateCartState(cart.item_count)}
    }catch(e){}
  };

  const render=()=>{updateButtons();renderDrawer()};

  document.addEventListener('click',e=>{
    const btn=e.target.closest('[data-wishlist-toggle]');
    if(btn){
      e.preventDefault();e.stopPropagation();
      const handle=btn.dataset.productHandle;
      let items=read();
      if(items.some(x=>x.handle===handle)) items=items.filter(x=>x.handle!==handle);
      else items.unshift({handle,title:btn.dataset.productTitle,url:btn.dataset.productUrl,image:btn.dataset.productImage||'',price:btn.dataset.productPrice||''});
      write(items);return;
    }
    const remove=e.target.closest('[data-wishlist-remove]');
    if(remove) write(read().filter(x=>x.handle!==remove.dataset.wishlistRemove));
  });

  document.addEventListener('cart:change',e=>updateCartState(e.detail?.cart?.item_count||0));
  document.addEventListener('cart:refresh',refreshCartState);
  window.addEventListener('pageshow',refreshCartState);
  window.addEventListener('storage',render);
  document.addEventListener('DOMContentLoaded',()=>{render();refreshCartState()});
  document.addEventListener('shopify:section:load',()=>{render();refreshCartState()});
  render();
})();
